import React from "react";

import Svg, { Circle, Rect } from "components/Svg";


const HomeCircle = props => (
	<Svg height={100} width={100}>
		<Circle
			cx={50}
			cy={50}
			r={45}
			strokeWidth={2.5}
			stroke="#e74c3c"
			fill="#f1c40f"
		/>
		<Rect
			x={15}
			y={15}
			width={70}
			height={70}
			strokeWidth={2}
			stroke="#9b59b6"
			fill="#3498db"
		/>
	</Svg>
);

export default HomeCircle;



// WEBPACK FOOTER //
// ./src/components/svgs/HomeCircle/index.js